import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { FaPaperclip } from 'react-icons/fa';
import './Violation.css';
import AttachmentsPopup from './AttachmentsPopup';

const VIOLATION_OPTIONS = [
  'Mobile phone use','Not wearing Seat Belt','Eating/Drinking while driving','Smoking inside cabin','Not wearing coverall','Distracted while driving','Unsafe posture while driving','Fatigued while driving','Overspeeding','Harsh Breaking','Harsh Acceleration','Driving too close to other vehicles','Night Driving','Rest violation','Not following JP','Tampering the devices','Unauthorized Passenger','Other'
];

const EditViolation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState('');
  const [showAttachments, setShowAttachments] = useState(false);
  const [trucks, setTrucks] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    loadViolation();
    fetchInTransitTrucks();
  }, [id]);

  const fetchInTransitTrucks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/inTransitTrucks`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const raw = response.data || [];
      const normalized = raw.map((t) => ({
        journey_plane_no: t.JOURNEY_PLANE_NO || t.journey_plane_no || '',
        scheduled_vehicle: t.SCHEDULED_VEHICLE || t.scheduled_vehicle || '',
        driver_name: t.DRIVER_NAME || t.driver_name || '',
        driver_phone: t.DRIVER_PHONE || t.driver_phone || '',
        driver_id: t.DRIVER_ID || t.driver_id || '',
        carrier: t.CARRIER || t.carrier || '',
        ivms_point: t.IVMS_POINT || t.ivms_point || '',
        jp_status: t.JP_STATUS || t.jp_status || ''
      }));
      setTrucks(normalized);
    } catch (err) {
      console.error('Error fetching in-transit trucks:', err);
    }
  };

  const loadViolation = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/driver-violations/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const json = response.data;
      let remarksVal = '';
      if (json.REMARKS !== undefined && json.REMARKS !== null) {
        if (typeof json.REMARKS === 'string') {
          remarksVal = json.REMARKS;
        } else if (typeof json.REMARKS === 'object') {
          try {
            const keys = Object.keys(json.REMARKS);
            if (keys.length === 0) {
              remarksVal = '';
            } else {
              remarksVal = JSON.stringify(json.REMARKS);
            }
          } catch (e) {
            remarksVal = '';
          }
        } else {
          remarksVal = String(json.REMARKS);
        }
      }

      setForm({
        journey_plane_no: json.JOURNEY_PLANE_NO || json.journey_plane_no || '',
        scheduled_vehicle: json.SCHEDULED_VEHICLE || json.scheduled_vehicle || '',
        driver_name: json.DRIVER_NAME || json.driver_name || '',
        driver_phone: json.DRIVER_PHONE || json.driver_phone || '',
        driver_id: json.DRIVER_ID || json.driver_id || '',
        carrier: json.CARRIER || json.carrier || '',
        violation: json.VIOLATION || VIOLATION_OPTIONS[0],
        remarks: remarksVal,
        violation_time: json.VIOLATION_TIME ? new Date(json.VIOLATION_TIME).toISOString().slice(0,16) : '',
        jp_status: json.JP_STATUS || json.jp_status || '',
        ivms_point: json.IVMS_POINT || json.ivms_point || ''
      });
    } catch (error) {
      console.error('Error fetching violation:', error);
      setMessage('Failed to load violation.');
      setTimeout(() => setMessage(''), 5000);
    }
  };

  const handleTruckSelection = (e) => {
    const { value } = e.target;
    const val = (value || '').toString().trim();
    const selectedTruck = trucks.find(
      (truck) => (truck.journey_plane_no || '').toString().trim() === val || (truck.scheduled_vehicle || '').toString().trim() === val
    );

    if (selectedTruck) {
      setForm((prev) => ({
        ...prev,
        journey_plane_no: selectedTruck.journey_plane_no,
        scheduled_vehicle: selectedTruck.scheduled_vehicle,
        driver_name: selectedTruck.driver_name,
        driver_phone: selectedTruck.driver_phone || '',
        carrier: selectedTruck.carrier,
        ivms_point: selectedTruck.ivms_point || '',
        jp_status: selectedTruck.jp_status || '',
      }));
    }
  };

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const body = { 
        ...form, 
        violation_time: new Date(form.violation_time).toISOString() 
      };
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_API_URL}/driver-violations/${id}`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage('Violation updated successfully.');
      setTimeout(() => {
        setMessage('');
        navigate('/driver-violations');
      }, 2000);
    } catch (err) {
      console.error('Error updating violation:', err);
      setMessage('Failed to update violation.');
      setTimeout(() => setMessage(''), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!form) return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;

  return (
    <div className="container-add-violation">
      <button className="close-button" onClick={() => navigate('/driver-violations')}>×</button>
      <h2 className="violation-form-header">✏️ Edit Driving Violation</h2>

      {message && (
        <div className={`violation-message ${message.includes('successfully') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <div className="violation-form-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Journey / JP No</label>
              <select 
                name="journey_plane_no" 
                value={form.journey_plane_no} 
                onChange={handleTruckSelection}
              >
                <option value="">-- Select Journey --</option>
                {form.journey_plane_no && !trucks.some(t => (t.journey_plane_no || '').toString().trim() === (form.journey_plane_no || '').toString().trim()) && (
                  <option value={form.journey_plane_no}>{form.journey_plane_no} (current)</option>
                )}
                {trucks.map((truck) => (
                  <option key={truck.journey_plane_no} value={truck.journey_plane_no}>
                    {truck.journey_plane_no}
                  </option>
                ))}
              </select>
            </div>
            <div className="violation-form-group">
              <label>Vehicle</label>
              <select 
                name="scheduled_vehicle" 
                value={form.scheduled_vehicle} 
                onChange={handleTruckSelection}
              >
                <option value="">-- Select Vehicle --</option>
                {form.scheduled_vehicle && !trucks.some(t => (t.scheduled_vehicle || '').toString().trim() === (form.scheduled_vehicle || '').toString().trim()) && (
                  <option value={form.scheduled_vehicle}>{form.scheduled_vehicle} (current)</option>
                )}
                {trucks.map((truck) => (
                  <option key={truck.scheduled_vehicle} value={truck.scheduled_vehicle}>
                    {truck.scheduled_vehicle}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Driver Name</label>
              <input type="text" name="driver_name" value={form.driver_name} readOnly />
            </div>
            <div className="violation-form-group">
              <label>Driver Phone</label>
              <input type="text" name="driver_phone" value={form.driver_phone} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Carrier</label>
              <input type="text" name="carrier" value={form.carrier} readOnly />
            </div>
            <div className="violation-form-group">
              <label>IVMS Point</label>
              <input type="text" name="ivms_point" value={form.ivms_point} readOnly />
            </div>
          </div>

          <div className="violation-form-row full">
            <div className="violation-form-group">
              <label>Violation Type *</label>
              <select name="violation" value={form.violation} onChange={handleChange} required>
                {VIOLATION_OPTIONS.map(v => (<option key={v} value={v}>{v}</option>))}
              </select>
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Violation Time *</label>
              <input
                type="datetime-local"
                name="violation_time"
                value={form.violation_time}
                onChange={handleChange}
                required
              />
            </div>
            <div className="violation-form-group">
              <label>JP Status</label>
              <input type="text" name="jp_status" value={form.jp_status} readOnly />
            </div>
          </div>

          <div className="violation-form-row full">
            <div className="violation-form-group">
              <label>Remarks</label>
              <textarea name="remarks" value={form.remarks} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-actions">
            <button type="submit" className={`submit ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Update Violation</button>
            <button type="button" className="cancel" onClick={() => navigate('/driver-violations')}>
              Cancel
            </button>
            <button 
              type="button" 
              title="Manage attached files for this violation" 
              className="attachment-icon-btn"
              onClick={() => setShowAttachments(true)}
              style={{ 
                background: 'none', 
                border: 'none', 
                fontSize: '20px', 
                cursor: 'pointer', 
                color: '#0066cc',
                marginLeft: '8px',
                padding: '8px',
                borderRadius: '50%',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#e8f0ff';
                e.target.style.transform = 'scale(1.15)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.transform = 'scale(1)';
              }}
            >
              <FaPaperclip />
            </button>
          </div>
        </form>
      </div>
      {showAttachments && (
        <AttachmentsPopup violationId={parseInt(id)} onClose={() => setShowAttachments(false)} />
      )}
    </div>
  );
};

export default EditViolation;
